import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  codingQuestions: [],
  codingQuestion: {
    title: '',
    question: '',
    codeList: '',
    references: '',
    otherSources: '',
    answer: '',
    status: 1,
    assignedTo: '',
    questionType: 'Acute'
  },
  codingQuestionStatusList: [],
  consultantList: []
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
